// src/components/forms/FormField.js
// Wrapper de field com controle de span no FormGrid.
// span={1} — coluna única (default)
// span={2} — coluna inteira (endereço, observações, textarea)

import React from 'react'
import { Box } from '@mui/material'

export default function FormField({ children, span = 1, sx }) {
  return (
    <Box
      sx={{
        gridColumn: { xs: 'span 1', sm: `span ${span}` },
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}
